import { readErrorMessage } from "../../utils/apiError";
import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../../utils/constants";
import CustomStepper from "../../components/CustomStepper";
import ReusableTable from "../../components/ReusableTable";
import LoadingSpinner from "../../components/LoadingSpinner";
import DatePicker from "react-datepicker";
import { useAuth } from "../../components/AuthProvider";
import ClearForm from "../../components/Clearform";
import { Form } from "react-bootstrap";

const Sect17Order = () => {
  const [sec17OrderNotCreatedLots, setSec17OrderNotCreatedLots] = useState([]);
  const [sec17OrderNotCreatedData, setSec17OrderNotCreatedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedLotNo, setSelectedLotNo] = useState(null);
  const [selectedClientID, setSelectedClientID] = useState(null);
  const [selectedProductID, setSelectedProductID] = useState(null);
  const [selectedArbitratorID, setSelectedArbitratorID] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);
  const [theDate, setTheDate] = useState("");
  const [nameOfAdvocate, setNameOfAdvocate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [showData, setShowData] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [save, setSave] = useState(false);
  const [showPDF, setShowPDF] = useState(false);
  const [upload, setUpload] = useState(false);
  const [clearForm, setClearForm] = useState(false);
  const { user, logout } = useAuth();
  const [arbId, setArbId] = useState(null);
  const [receivedData, setReceivedData] = useState([]);
  const [getData, setGetData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [showCertifiedUpload, setShowCertifiedUpload] = useState(false);
  const [certifiedFile, setCertifiedFile] = useState(null);
  const [certifiedDate, setCertifiedDate] = useState(null);
  const [certifiedDateStr, setCertifiedDateStr] = useState("");
  const [formError, setFormError] = useState("");
  const [certifiedFileError, setCertifiedFileError] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const rowsPerPage = 10;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [hearingType, setHearingType] = useState("");

  const handleHearingChange = (e) => {
    setHearingType(Number(e.target.value));
    if (e.target.value) setFormError("");
  };

  useEffect(() => {
    setArbId(user[0].Ref_id);
  }, [user]);

  useEffect(() => {
    const fetchSec17OrderNotCreatedLots = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/pendingSec17Order?Arb_id=${arbId}`
        );
        if (!response.ok) {
          throw new Error(await readErrorMessage(response));
        }
        const result = await response.json();
        const parsedNotServedLots = Array.isArray(result)
          ? result
          : JSON.parse(result);
        setSec17OrderNotCreatedLots(parsedNotServedLots);
      } catch (error) {
        // Optional: setError1(error.message);
        console.error("Error fetching Sec17 Order Not Created Lots:", error);
      } finally {
        setLoading(false);
      }
    };

    if (arbId !== null && arbId !== undefined) {
      fetchSec17OrderNotCreatedLots();
    }
  }, [arbId]);

  const searchFields = ["Arb_name", "Lots"];

  const filteredLots = sec17OrderNotCreatedLots.filter((item) =>
    searchFields.some((key) =>
      item[key]?.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredLots.slice(indexOfFirstRow, indexOfLastRow);

  useEffect(() => {
    if (sec17OrderNotCreatedLots.length > 0) {
      const updatedData = sec17OrderNotCreatedLots.map((item, index) => {
        const {
          SR_No,
          assign_id,
          Arbitrator_id,
          Case_id,
          UPLODED_DATE,
          ...rest
        } = item;
        return {
          // SrNo: index + 1,
          ...rest,
        };
      });

      setReceivedData(sec17OrderNotCreatedLots);
      setGetData(updatedData);
      setShowTable(true);
      //   handleStepChange(1);
    }
  }, [sec17OrderNotCreatedLots]); // Watch for changes in draftNotCreatedData

  // for reusableTable Fixed starts
  const columns = [
    { header: "Sr No" },
    { header: "Lots" },
    { header: "Arbitrator" },
    { header: "Actions" },
  ];
  // for pagination of reusabletableFixed
  const totalPages = Math.ceil(setSec17OrderNotCreatedLots.length / 10); // Example calculation
  const displayedPages = Array.from({ length: totalPages }, (_, i) => i + 1); // Example pagination logic
  const startIndex = (currentPage - 1) * 10;
  // for pagination of reusabletableFixed

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  // for reusableTable Fixed ends

  // For the customStepper starts Here
  const steps = [
    "Select Lot",
    "Save Section 17 Order",
    "Generate Section 17 Order",
    "Upload Section 17 Order",
    "Upload Certified Order",
  ];

  // Function to move to a specific step in Stepper Component
  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  // For the customStepper ends Here

  //   for the getting data of selected lot to create refernce Draft starts
  const handleRowAction = async (item) => {
    setSelectedLotNo(item.Lot_no);
    setSelectedClientID(item.Client_id);
    setSelectedProductID(item.Product_id);
    setSelectedArbitratorID(item.Arb_id);
    setLoading(true);
    handleStepChange(1);
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/pendingSec17Order?Lot_no=${item.Lot_no}&Client_id=${item.Client_id}&Product_id=${item.Product_id}&Arb_id=${item.Arb_id}`
      );
      if (!response.ok) {
        throw new Error(await readErrorMessage(response));
      }
      const result = await response.json();

      const parsedNotSec17Lots = Array.isArray(result)
        ? result
        : JSON.parse(result); // Ensure parsedArbitrators is an array
      setSec17OrderNotCreatedData(parsedNotSec17Lots);
      setLoading(false);
      setShowData(true);
    } catch (error) {
      // setError1(error.message);
    }
  };

  //   for pagination of reusable table starts
  const [currentPage1, setCurrentPage1] = useState(1); // Current page for ReusableTable
  const [itemsPerPage] = useState(10); // Number of items per page
  const totalItems1 = sec17OrderNotCreatedData.length;
  const totalPages1 = Math.ceil(totalItems1 / itemsPerPage);
  const startIndex1 = (currentPage1 - 1) * itemsPerPage;
  const currentItems1 = sec17OrderNotCreatedData.slice(
    startIndex1,
    startIndex1 + itemsPerPage
  );
  const pageNumbers1 = Array.from({ length: totalPages1 }, (_, i) => i + 1);
  //   for pagination of reusable table ends

  if (loading) return <LoadingSpinner />;

  const handleDateChange = (date) => {
    setFormError("");
    if (date && date instanceof Date && !isNaN(date)) {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      setSelectedDate(date);
      setTheDate(`${month}-${day}-${year}`);
    } else {
      setSelectedDate(null);
      setTheDate("");
    }
  };

  // Date Change function Ends Here

  const handleNameChange = (e) => {
    setNameOfAdvocate(e.target.value);
    if (e.target.value.trim()) setFormError("");
  };

  // TO Save the SOC Records  with Date starts
  const handleSaveSec17Order = async () => {
    if (!theDate) {
      setFormError("Please select a Section 17 Order date.");
      return;
    }
    setFormError("");

    const dataToGenerateSOC = sec17OrderNotCreatedData.map((item) => ({
      Case_id: item.Case_id || item.caseId,
      Sec_17_order_date: theDate,
    }));
    try {
      setLoading(true);
      // The server first checks every order can be made (Word file, details, signature, stamp); if not, nothing is saved
      const response = await fetch(`${API_BASE_URL}/api/Sec17OrderSave`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToGenerateSOC),
      });
      if (!response.ok) {
        throw new Error(await readErrorMessage(response));
      }
      handleStepChange(2);
      setSave(true);
    } catch (error) {
      console.error("Error uploading data:", error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };
  // TO Save the Records ends

  // for the generation of SOC function starts
  const handleGenerateSec17Order = async () => {
    if (!nameOfAdvocate || !nameOfAdvocate.trim()) {
      setFormError("Please enter the Advocate Name.");
      return;
    }
    if (!hearingType) {
      setFormError("Please select a Hearing Type.");
      return;
    }
    setFormError("");

    setLoading(true);
    const encodedName = encodeURIComponent(nameOfAdvocate);
    try {
      // Fetch the PDF file from the API
      const response = await fetch(
        `${API_BASE_URL}/api/Sec17Orderletter?Lot_no=${selectedLotNo}&Client_id=${selectedClientID}&Product_id=${selectedProductID}&Arb_id=${selectedArbitratorID}&adv=${encodedName}&type=${hearingType}`
      );
      if (!response.ok) {
        throw new Error(await readErrorMessage(response));
      }

      // Convert the response to a Blob
      const pdfBlob = await response.blob();
      // Create a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
      // Set the PDF URL to the state
      setPdfUrl(pdfUrl);
      // setPdfUrl(pdfUrl);
      setShowPDF(true);
      setUpload(true);
      handleStepChange(3);
    } catch (error) {
      console.error("Error fetching and displaying the PDF:", error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };
  // for the generation of dearft function ends

  const handleUploadSec17Order = async () => {
    if (!nameOfAdvocate || !nameOfAdvocate.trim()) {
      setFormError("Please enter the Advocate Name.");
      return;
    }
    if (!hearingType) {
      setFormError("Please select a Hearing Type.");
      return;
    }
    setFormError("");

    setLoading(true);
    const encodedName = encodeURIComponent(nameOfAdvocate);
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/SaveSec17OrderCase?Lot_no=${selectedLotNo}&Client_id=${selectedClientID}&Product_id=${selectedProductID}&Arb_id=${selectedArbitratorID}&adv=${encodedName}&type=${hearingType}`
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to upload data: ${response.status} ${response.statusText} - ${errorText}`
        );
      }

      const result = await response.json();
      setShowCertifiedUpload(true);
      handleStepChange(4);
    } catch (error) {
      console.error("Error uploading data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCertifiedDateChange = (date) => {
    if (date && date instanceof Date && !isNaN(date)) {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      const formattedDate = `${month}-${day}-${year}`;
      setCertifiedDate(date);
      setCertifiedDateStr(formattedDate);
    } else {
      setCertifiedDate(null);
      setCertifiedDateStr("");
    }
  };

  const handleCertifiedFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (file.type !== "application/pdf" && !file.name.toLowerCase().endsWith(".pdf")) {
      setCertifiedFile(null);
      setCertifiedFileError("Only PDF files are allowed.");
      event.target.value = "";
      return;
    }
    setCertifiedFile(file);
    setCertifiedFileError("");
  };

  const handleUploadCertifiedOrder = async () => {
    if (!certifiedFile || !certifiedDateStr) {
      alert("Please select a PDF file and certified date");
      return;
    }

    setLoading(true);
    try {
      // Create data array for all cases in the lot
      const data = sec17OrderNotCreatedData.map((item) => ({
        Reference_no: item.referenceNo || item.Reference_no,
        Certified_date: certifiedDateStr,
      }));

      const formData = new FormData();
      formData.append("file", certifiedFile);
      formData.append("data", JSON.stringify(data));

      // Calculate page interval (1 page per case for certified orders)
      const pageInterval = 1;

      const response = await fetch(
        `${API_BASE_URL}/api/UploadCertifiedSec17Order?PageInterval=${pageInterval}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        let errorMsg = "Upload failed. Please try again.";
        try {
          const errorData = await response.json();
          errorMsg = errorData.message || errorMsg;
        } catch (_) { }
        setError(errorMsg);
        return;
      }

      const result = await response.json();
      setError("");
      setClearForm(true);
    } catch (error) {
      console.error("Error uploading certified order:", error);
      setError(error.message || "Error uploading certified order.");
    } finally {
      setLoading(false);
    }
  };
  //   function to upload the reference Drafts ends Here

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 mb-3">
          <CustomStepper steps={steps} activeStep={activeStep} />
        </div>
      </div>

      {!showData && (
        <div className="row table-container mt-3">
          <div className="col-md-12 mx-auto table-wrapper">
            {/* Search Input */}
            <div className="mb-3 d-flex justify-content-start">
              <input
                type="text"
                placeholder="Search Lots..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1); // reset to first page on search
                }}
                className="form-control"
                style={{ maxWidth: "300px" }}
              />
            </div>

            {/* Table */}
            <table className="responsive-table my-3">
              <thead className="text-center">
                <tr className="table-info">
                  <th scope="col" className="text-center">
                    Sr No
                  </th>

                  {/* <th scope="col" className="text-center">
                    Assigned Date
                  </th> */}

                  <th scope="col" className="text-center">
                    Lots
                  </th>
                  <th scope="col" className="text-center">
                    Arbitrator Name
                  </th>
                  <th scope="col" className="text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentRows.length > 0 ? (
                  currentRows.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-center">
                        {indexOfFirstRow + index + 1}
                      </td>
                      <td className="text-center">{item.Lots}</td>
                      <td className="text-center">{item.Arb_name}</td>
                      <td className="text-center">
                        <button
                          onClick={() => handleRowAction(item)}
                          className="custBtn"
                        >
                          Show
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-muted">
                      No results found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination */}
            <div className="d-flex justify-content-center">
              <nav>
                <ul className="pagination">
                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i + 1}
                      className={`page-item ${currentPage === i + 1 ? "active" : ""
                        }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      )}

      {showData && (
        <div className="row">
          {/* <div className="col-md-6">
            {!save && (
              <DatePicker
                selected={selectedDate} // Set the selected date
                onChange={handleDateChange}
                placeholderText="Select a date"
                dateFormat="dd/MM/yyyy" // Use dd/MM/yyyy format
                className="form-control custom_input" // Smaller size
                id="datePicker"
                style={{
                  width: "100%",
                  // height: "calc(1.5em + .75rem + 2px)",
                  // padding: ".375rem .75rem",
                  fontSize: "12px",
                  borderRadius: ".25rem",
                  border: "1px solid #ced4da",
                  boxSizing: "border-box",
                }}
              />
            )}
            {save && !showPDF && (
              <Form.Control
                type="text"
                className="custom_input"
                placeholder="Advocate Name"
                onChange={handleNameChange}
                value={nameOfAdvocate}
                style={{ fontSize: "12px" }}
              />
            )}
          </div> */}
          <div className="col-md-6">
            {/* Date Picker */}
            {!save && (
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                placeholderText="Select a date"
                dateFormat="dd/MM/yyyy"
                className="form-control custom_input"
                id="datePicker"
                style={{
                  width: "100%",
                  fontSize: "12px",
                  borderRadius: ".25rem",
                  border: "1px solid #ced4da",
                  boxSizing: "border-box",
                }}
              />
            )}

            {/* Advocate Name */}
            {save && !showPDF && (
              <Form.Control
                type="text"
                className="custom_input"
                placeholder="Advocate Name"
                onChange={handleNameChange}
                value={nameOfAdvocate}
                style={{ fontSize: "12px", marginBottom: "8px" }}
              />
            )}
          </div>

          <div className="col-md-4">
            {/* Hearing Type Dropdown */}
            {save && !showPDF && (
              <Form.Select
                className="custom_input"
                onChange={handleHearingChange}
                value={hearingType}
                style={{ fontSize: "12px" }}
              >
                <option value="">Select Hearing Type</option>
                <option value={1}>First Hearing</option>
                <option value={2}>Second Hearing</option>
              </Form.Select>
            )}
          </div>
          <div className="col-md-2">
            {!save && (
              <button className="custBtn" onClick={handleSaveSec17Order}>
                Save
              </button>
            )}
            {save && !showPDF && (
              <button className="custBtn" onClick={handleGenerateSec17Order}>
                Generate
              </button>
            )}
            {showPDF && !clearForm && !showCertifiedUpload && (
              <button className="custBtn" onClick={handleUploadSec17Order}>
                Upload Order
              </button>
            )}
          </div>

          {formError && (
            <div className="col-md-12 mt-2">
              <div style={{ color: "red", background: "#ffe6e6", padding: "8px 12px", borderRadius: "5px", fontSize: "13px" }}>
                {formError}
              </div>
            </div>
          )}
        </div>
      )}

      {showPDF && !clearForm && !showCertifiedUpload && (
        <div className="row mt-3">
          <div className="col-md-12">
            <iframe
              src={pdfUrl}
              style={{ width: "100%", height: "100vh" }}
              title="PDF Viewer"
            />
          </div>
        </div>
      )}

      {showCertifiedUpload && !clearForm && (
        <div className="row mt-3">
          <div className="col-md-12">
            <h4>Upload Certified Section 17 Order</h4>
            <p className="text-muted">
              Upload the court-certified Section 17 Order. This will be used for sending services to borrowers.
            </p>
          </div>
          <div className="col-md-4">
            <DatePicker
              selected={certifiedDate}
              onChange={handleCertifiedDateChange}
              placeholderText="Select certified date"
              dateFormat="dd/MM/yyyy"
              className="form-control custom_input"
              style={{
                width: "100%",
                fontSize: "12px",
                borderRadius: ".25rem",
                border: "1px solid #ced4da",
              }}
            />
          </div>
          <div className="col-md-4">
            <Form.Control
              type="file"
              accept=".pdf"
              onChange={handleCertifiedFileChange}
              className="custom_input"
              style={{ fontSize: "12px" }}
            />
            {certifiedFileError && (
              <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                {certifiedFileError}
              </div>
            )}
          </div>
          <div className="col-md-4">
            <button
              className={!certifiedFile || !certifiedDateStr || certifiedFileError ? "disabledBtn" : "custBtn"}
              onClick={handleUploadCertifiedOrder}
              disabled={!certifiedFile || !certifiedDateStr || !!certifiedFileError}
            >
              Upload Certified Order
            </button>
          </div>
          <div className="col-md-12 mt-3">
            <div className="alert alert-info">
              <strong>Note:</strong>&nbsp;
              Make sure the PDF contains one page per case in the same order as the table below.
            </div>
          </div>
          {error && (
            <div className="col-md-12 mt-2">
              <div
                style={{
                  color: "red",
                  background: "#ffe6e6",
                  padding: "10px",
                  borderRadius: "5px",
                  fontSize: "13px",
                }}
              >
                {error}
              </div>
            </div>
          )}
        </div>
      )}

      {showData && !showPDF && !showCertifiedUpload && (
        <div className="row">
          <div className="col-md-12 mt-3">
            <ReusableTable
              data={currentItems1}
              currentPage={currentPage1}
              pageNumbers={pageNumbers1}
              setCurrentPage={setCurrentPage1}
            />
          </div>
        </div>
      )}

      {showCertifiedUpload && !clearForm && (
        <div className="row">
          <div className="col-md-12 mt-3">
            <ReusableTable
              data={currentItems1}
              currentPage={currentPage1}
              pageNumbers={pageNumbers1}
              setCurrentPage={setCurrentPage1}
            />
          </div>
        </div>
      )}

      {clearForm && (
        <div className="row">
          <div className="col-md-12 d-flex justify-content-center ">
            <ClearForm
              message="Section 17 Order Process Completed Successfully!"
              redirectPath="/arbdashboard"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Sect17Order;
